<script setup>
import { onUnmounted, watch, onMounted, computed, ref } from 'vue';
import Sidebar from '../Sidebar.vue';
import Topbar from '../Topbar.vue';
import { isLg, isXl } from '@utils/mediaQuery';
import { Alert, MediaUploaderModal, Icon, Tabs, Tab } from '@components';
import { mediaUploader } from '@utils/mediaUploader';
import draggable from "vuedraggable";

import Menu from './Menu.vue';
import MenuSidebar from "./MenuSidebar.vue";
import MenuDesignBar from "./MenuDesignBar.vue";

import { useCustomizer } from '@store/customizer';
const $customizer = useCustomizer();

import { useSettings } from '@store/settings';
const $settings = useSettings();

import { useRoute } from 'vue-router';
const route = useRoute();

watch(route, (to, from) => {
    if (to.name !== from.name) {
        mediaUploader.selectImage('undefined');
    }
});

const fieldsMapping = {
    business_custom_name: 'name',
    business_custom_about: 'about',
    provider_display_name: 'provider_display_name',
    provider_bio: 'provider_bio'
};

onMounted(() => {
    let hasChanges = false;
    for (const [sidebarKey, businessKey] of Object.entries(fieldsMapping)) {
        if ($settings.customizer.sidebar[sidebarKey] === '') {
            $settings.customizer.sidebar[sidebarKey] = $settings.business[businessKey];
            hasChanges = true;
        }
    }

    if (hasChanges) {
        console.log('ok');
        $settings.saveSettings('customizer', $settings.customizer);
    }
});

const changeSidebar = (event) => {
    setTimeout(() => {
        let i = 1;
        sidebarMenu.value.forEach((menu, index) => {
            $settings.customizer[menu.id]['priority'] = i++;
        });

        // $settings.saveSettings('customizer', $settings.customizer)
    }, 10);
};


const sidebarMenu = ref($customizer.sidebarFormMenu.filter(menu => menu.visible && !['booking_overview'].includes(menu.id)).sort((a, b) => a.priority - b.priority) || []);

const checkMove = (event) => {
    // console.log('checkMove', event);

    // time cannot be equal or less then date, staff, service
    const maxIndex = Math.max(...[sidebarMenu.value.findIndex(menu => menu.id == 'date'), sidebarMenu.value.findIndex(menu => menu.id == 'staff'), sidebarMenu.value.findIndex(menu => menu.id == 'service')]);
    if (event.draggedContext.element.id == 'time' && event.draggedContext.futureIndex <= maxIndex) return false;

    // date, staff, service cannot be equal or more then time
    if (['date', 'staff', 'service'].includes(event.draggedContext.element.id) && event.draggedContext.futureIndex >= sidebarMenu.value.findIndex(menu => menu.id == 'time')) return false;

    return true;
};
</script>

<template>
<div class="min-h-screen">
    <Alert class="fixed z-50 top-3 right-5" />
    <MediaUploaderModal />
    <div class="sticky top-0 z-[1]">
        <Topbar />
        <Sidebar>
            <!-- {{ sidebarMenu.map(menu => {
                    return {
                        title: menu.title,
                        priority: menu.priority
                    }
                }) }} -->
            <div @click="$customizer.cancel(true)"
                class="cursor-pointer w-full hover:bg-[#F2F4F7] px-3 py-2 flex items-center gap-3 text-[#344054] text-base font-semibold rounded-md mb-6">
                <Icon name="reverseLeft" size="24px" class="text-[#667085]" />
                Back to Dashboard
            </div>

            <Tabs default="steps" key="mainTabs" design="underline">
                <Tab id="sidebar">Sidebar</Tab>
                <Tab id="steps">Steps</Tab>
                <Tab id="design">Design</Tab>


                <template #sidebar>
                    <MenuSidebar />
                </template>

                <template #steps>
                    <!-- {{ sidebarMenu.map(menu => {
                        return {
                            title: menu.title,
                            priority: menu.priority
                        }
                    }) }} -->
                    <!-- <transition name="fade" mode="out-in"> -->
                    <draggable :list="sidebarMenu" class="flex flex-col" group="menu-item" ghost-class="ghost"
                        @end="changeSidebar" :move="checkMove">
                        <template #item="{ element, index }">
                            <Menu class="menu-item" :key="element.title" :menu="element" :serial="index + 1"
                                :totalMenu="sidebarMenu.length" :menuIndex="index" :data-title="element.title" />
                        </template>
                    </draggable>
                    <Menu class="menu-item" :key="$customizer.sidebarOverview.title" :menu="$customizer.sidebarOverview"
                        :serial="sidebarMenu.length + 1" :totalMenu="sidebarMenu.length" :menuIndex="index"
                        :data-title="$customizer.sidebarOverview.title" :draggable="false" />

                    <!-- </transition> -->

                </template>

                <template #design>
                    <MenuDesignBar />
                </template>
            </Tabs>
        </Sidebar>
    </div>

    <main class="py-[32px] bg-[#F9FAFB] h-screen overflow-y-scroll prebook-customizer" :style="{
        paddingLeft: (isLg || isXl) ? $customizer.sidebarWidth : '',
    }">
        <router-view v-slot="{ Component }">
            <component :is="Component"></component>
        </router-view>

    </main>
</div>
</template>


<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}
</style>